import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { LigneFinancementMarche } from '../../model/ligneFinancement/ligneFinancementMarche';

@Injectable({
  providedIn: "root"
})
export class LigneFinancementMarcheService {
  constructor(private _restClientService: RestClientService) {}

  getAllLigneFinancementMarche() {
    return this._restClientService.load<LigneFinancementMarche[]>(
      "ligne-financement-marche/find-all"
    );
  }

  getById(id) {
    return this._restClientService.load<LigneFinancementMarche>(
      "ligne-financement-marche/find-by-id//" + id
    );
  }

  add(ligneFinancement) {
    return this._restClientService.save<LigneFinancementMarche>(
      "ligne-financement-marche/add",
      ligneFinancement
    );
  }

  update(ligneFinancement) {
    return this._restClientService.put<LigneFinancementMarche>(
      `ligne-financement-marche/update`,
      ligneFinancement
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "ligne-financement-marche/delete/" + id
    );
  }
}
